export default "__VITE_ASSET__Dxg_BpxW__"